import axios from "axios";
import { getLoggedUser } from "../../../state/user";
import { apiUrl } from "../../../constants/global";

const endpoint = apiUrl + "v2";

export async function getNotificationCounts() {
  const user = getLoggedUser();

  if (!user?.token) {
    return { status: false, message: "No token found", count: 0 };
  }

  try {
    const { data } = await axios.get(
      `${endpoint}/notifications-count`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    return data;
  } catch (error) {
    console.error("API Error:", error);
    return {
      status: false,
      message: error.response?.data?.message || "Something went wrong",
      count: 0,
    };
  }
}
